import { ContentItem } from '@/features/content/ContentItem';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/content/$contentId')({
  staticData: { nav: 'content' },
  component: ContentItem,
});
